import { Rect } from './rect';

function from({ x, y, width, height }: { x?: number; y?: number; width?: number; height?: number }) {
  return {
    x: x ?? 0,
    y: y ?? 0,
    width: width ?? 0,
    height: height ?? 0,
  };
}
function getMinX(rect: Rect) {
  return rect.x;
}

function getMidX(rect: Rect) {
  return rect.x + rect.width / 2;
}

function getMaxX(rect: Rect) {
  return rect.x + rect.width;
}

function getMinY(rect: Rect) {
  return rect.y;
}

function getMidY(rect: Rect) {
  return rect.y + rect.height / 2;
}

function getMaxY(rect: Rect) {
  return rect.y + rect.height;
}

function getSizeX(rect: Rect) {
  return rect.width;
}

function getSizeY(rect: Rect) {
  return rect.height;
}

function isInside({ rect, inside }: { rect: Rect; inside: Rect }) {
  return rect.x >= inside.x && rect.y >= inside.y && rect.x + rect.width <= inside.x + inside.width && rect.y + rect.height <= inside.y + inside.height;
}

export const RectFuncs = {
  from,
  getMinX,
  getMidX,
  getMaxX,
  getMinY,
  getMidY,
  getMaxY,
  getSizeX,
  getSizeY,
  isInside,
};
